module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "fmh"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("One:   ")]), _vm._v("Hate Happens")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Two:   ")]), _vm._v("Why I Have No Friends, Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Three:   ")]), _vm._v("Yes, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Really")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Four:   ")]), _vm._v("How to Love the Man You Hate")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Five:   ")]), _vm._v("Hate Your Way to Happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Six:   ")]), _vm._v("That’s So Great!")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Seven:   ")]), _vm._v("How to Hate the Man You Love")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Eight:   ")]), _vm._v("Why I Have No Friends, Part II")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Nine:   ")]), _vm._v("Why Pot Should Be Legal")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Ten:   ")]), _vm._v("The Enemies List")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Eleven:   ")]), _vm._v("I Hate Your Kids")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Twelve:   ")]), _vm._v("Can’t Complain")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Thirteen:   ")]), _vm._v("Anger Management")])]), _vm._v(" "), _c('p', {
    staticClass: "cct-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epi",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#not",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adc",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Also by Valerie Frankel")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#copy",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0